module.exports = __webpack_public_path__ + "static/media/HighFive_Converse_vertical.23484a68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HighFive_Converse_vertical.svg
// module id = 652
// module chunks = 0